import { supabase } from '../lib/supabase';

export async function getAdminReservations() {
  const { data, error } = await supabase
    .from('reservations')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) {
    throw new Error(error.message);
  }

  return data || [];
}

export async function updateReservationStatus(reservationId, status) {
  const { data, error } = await supabase.functions.invoke('update-reservation-status', {
    body: {
      reservation_id: reservationId,
      status,
    },
  });

  if (error) {
    throw new Error(error.message || 'Erreur mise à jour réservation');
  }

  if (!data?.success) {
    throw new Error(data?.message || 'Erreur mise à jour réservation');
  }

  return data.reservation;
}